<ng-template #content let-modal>
  <div class="modal-content" style="padding: 25px;width: 541px;border-radius: 0px;">
    <div class="modal-header row">
      <span class="modal-title" id="modal-basic-title">{{'' | i18n: titleContent }}</span>
      <div class="col-lg-1">
        <button type="button" (click)="modal.close('Cancelled')">
          <i aria-hidden="true" data-dismiss="modal" aria-label="Close" class="fa fa-times"></i>
        </button>
      </div>
    </div>

    <div class="modal-body">
      <div class="cancel-contract-container">
        <div>
          <div>{{'' | i18n: confirmationMessage}}</div>
          @if (isInvoiced()) {
            <div class="yes-no-container">
              <span>{{'' | i18n: 'without-refund'}}</span>
              <span class="spacer">
                <input type="radio" id="accept_no" [value]="false" [(ngModel)]="refundSelected">
              </span>
              <span class="spacer">{{'' | i18n: 'with-refund'}}</span>
              <span class="spacer">
                <input type="radio" id="accept_yes" [value]="true" [(ngModel)]="refundSelected">
              </span>
            </div>
          }
        </div>
        @if (refundSelected) {
          <div>
            <div>
              <label>
                {{'' | i18n: 'refund-amount-wording'}}
                <span class="info">(max: {{ getPaidAmount() }})</span>
                <input type="number" [(ngModel)]="amount" (keyup)="validateInput()">
              </label>
              @if (amountError) {
                <div class="error">{{'' | i18n: 'amount-error'}}</div>
              }
              @if (amountValueError) {
                <div class="error">{{'' | i18n: 'amount-value-error'}}</div>
              }
            </div>
            <div>
              <label>
                {{'' | i18n: 'refund-comments-title'}}
                <textarea [(ngModel)]="comments" rows="5" cols="100%"></textarea>
              </label>
            </div>
          </div>
        }
      </div>
    </div>

    <div class="modal-footer">
      <button type="button" class="btn btn-back" (click)="modal.close('Cancelled')">
        {{'' | i18n: cancelButtonContent}}
      </button>
      <button type="button" class="btn btn-default" (click)="onCancel()" [disabled]="!validate()">
        {{'' | i18n: buttonContent}}
      </button>
    </div>
  </div>
</ng-template>
